// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { type Theme } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponent } from '@emotion/styled';
import { collapsedSearchInputWidth, dialogPageTakeoverWidth } from '../style-utils';
import type { DetailedHTMLProps, HTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SSRsearchInputContainer: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
	} & {
		shouldFillContainer?: boolean;
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression
	},
	DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
	{}
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled('div')<{ shouldFillContainer?: boolean }>`
	position: relative;
	max-width: 100%;
	@media screen and (max-width: ${dialogPageTakeoverWidth}px) {
		width: 100%;
	}
	width: ${(props) => {
		if (props.shouldFillContainer) {
			return '100%';
		}

		return collapsedSearchInputWidth;
	}};
`;
